import { useQuery } from '@tanstack/react-query';
import { codeApi } from '../api/codeApi';
import type { CodeGroupSearchCondition } from '../types/code';

/**
 * GET /api/eraf/codes/groups — 코드 그룹 목록 (페이징/검색/필터/정렬)
 * queryKey: ['common-code', 'list', filters]
 */
export function useCodeGroupList(filters: CodeGroupSearchCondition) {
  return useQuery({
    queryKey: ['common-code', 'list', filters],
    queryFn: () => codeApi.listGroups(filters),
    staleTime: 30_000,
  });
}
